import React, { useState, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPatientList } from "../../../../../redux/actions/dbactions/pateints";
import { setCurrentDataService } from "../../../../../redux/actions/dbactions/pateints";
import { getSession } from "../../../../../redux/actions/authActions";
import { BaseUrl } from "../../../../../redux/config";
import axios from "axios";
import { toast } from "react-toastify";

export const ServiceCard = ({ selectedId,
  svcProfileID,
  handleShow,
  data,
  handleEditModal,
  roleID,
  HandleClick,
  selectedColor,
  isDisabled,
  dispatch,
  bookingData,
  userData,
  selectedCardId,
  setSelectedCardId,
}) => {
  const [showMore, setShowMore] = useState(false);
  const {
    svc_name,
    svc_cat_desc,
    svc_typ_desc,
    svc_desc,
    svc_cost_amt,
    svc_id,
    order_num,
    order_svc_user_id,
  } = data;
  const { ord_svc_date, ord_svc_time } = bookingData || {};
  const { user_profile_id, role_id } = getSession();
  const [url, setUrl] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [isSelected, setIsSelected] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const cardRef = useRef(null);

  useEffect(() => {
    if (selectedCardId === svc_id) {
      setIsFocused(true);
    } else {
      setIsFocused(false);
    }
  }, [selectedCardId, svc_id]);

  const history = useHistory();
  const shouldText = svc_desc.length > 100;
  const displayText = showMore
    ? svc_desc
    : `${svc_desc.slice(0, 100)}${shouldText ? "..." : ""}`;
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Update the state with the input value
  };
  const handleCardClick = () => {
    HandleClick(); // Call the parent handler if necessary
    setIsSelected(true); // Set the card as selected
    setSelectedCardId(svc_id);
  };

  const handleFocus = () => {
    setSelectedCardId(svc_id); // Set this card as the focused one when it gains focus
  };
  
  const handleBookie = async () => {
    const { token } = getSession();

    dispatch(setCurrentDataService(data));

    if (svc_cost_amt == 0 || userData.order_id) {
      const postData = {
        ord_svc_date: ord_svc_date,
        ord_svc_time: ord_svc_time,
        ord_parent_order_id: userData.order_id,
        order_dte_tsp: "2022-07-15T12:00:00Z",
        order_tot_amt: svc_cost_amt,
        order_tot_tax: 0.0,
        order_tot_fees: 0.0,
        order_svcf_id: selectedId,
        user_profile_id: userData.user_profile_id,
        order_svc_user_id: userData.order_svc_user_id,
        order_ship_to_id: 2,
        order_ship_instructions: inputValue || "",
        order_bill_to_id: 2,
        order_status_id: 1,
        sys_user_id: user_profile_id,
        role_id: role_id,
        sys_source_ip: "192.168.2.2",
        sys_crte_tsp: "2022-07-15T12:00:00Z",
        sys_last_updte_tsp: "2022-07-15T12:30:00Z",
        sys_ord_active_yn: "Y",
        service_order_line: [
          {
            svc_id: data.svc_id,
            svc_name: data.svc_name,
            svc_qnty_nbr: 1,
            svc_status_id: 1,
            svc_price_amt: data.svc_cost_amt,
            svcfee_id: 1,
            sys_user_id: user_profile_id,
            sys_ordl_active_yn: "Y",
            sys_crte_tsp: "2022-07-15T12:00:00Z",
            sys_last_updte_tsp: "2022-07-15T12:30:00Z",
          },
        ],
      };
      try {
        let response = await axios.post(`${BaseUrl}serviceOrd/`, postData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        toast.success(response.data.usr.message);
        localStorage.removeItem("newOrder");
        history.push(`/dashboard/order`);
        return response.data;
      } catch (error) {
        localStorage.removeItem("newOrder");
        console.error("There was a problem with your Axios request:", error);
      }
    } else {
      const postData = {
        ord_svc_date: ord_svc_date,
        ord_svc_time: ord_svc_time,
        ord_parent_order_id: userData.order_id,
        order_dte_tsp: "2022-07-15T12:00:00Z",
        order_tot_amt: svc_cost_amt,
        order_tot_tax: 0.0,
        order_tot_fees: 0.0,
        order_svcf_id: userData.order_svcf_id,
        user_profile_id: user_profile_id,
        order_svc_user_id: userData.order_svc_user_id,
        order_ship_to_id: 2,
        order_ship_instructions: inputValue || "",
        order_bill_to_id: 2,
        order_status_id: 1,
        sys_user_id: user_profile_id,
        role_id: role_id,
        sys_source_ip: "192.168.2.2",
        sys_crte_tsp: "2022-07-15T12:00:00Z",
        sys_last_updte_tsp: "2022-07-15T12:30:00Z",
        sys_ord_active_yn: "Y",
        service_order_line: [
          {
            svc_id: data.svc_id,
            svc_name: data.svc_name,
            svc_qnty_nbr: 1,
            svc_status_id: 1,
            svc_price_amt: data.svc_cost_amt,
            svcfee_id: 1,
            sys_user_id: user_profile_id,
            sys_ordl_active_yn: "Y",
            sys_crte_tsp: "2022-07-15T12:00:00Z",
            sys_last_updte_tsp: "2022-07-15T12:30:00Z",
          },
        ],
      };
      try {
        let response = await axios.post(`${BaseUrl}pay/ps`, postData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        setUrl(response.data.session_url);
        localStorage.removeItem("newOrder");
        return response.data;
      } catch (error) {
        localStorage.removeItem("newOrder");
        console.error("There was a problem with your Axios request:", error);
      }
    }

    // request();
    localStorage.removeItem("newOrder");
  };

  const svc_cost_amtf = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(svc_cost_amt);

  return (
    <div
    ref={cardRef}
    onClick={handleCardClick}
    onFocus={handleFocus} // When the card gains focus, it becomes the selected one
    tabIndex="0" // Make card focusable
      className="facility"
      style={{
        paddingBottom: "10px",
        position: "relative",
        border:
          selectedColor === svc_id
            ? "2px solid #3b71ca"
            : "2px solid transparent",
        cursor: "pointer",
      }}
    >
      <h5>{svc_name}</h5>
      <p>
        {displayText}
        {shouldText && (
          <span onClick={toggleShowMore}>
            {" "}
            {showMore ? "Show Less" : "Show More"}
          </span>
        )}
      </p>

      <div className="h-full grid grid-cols-2">
        <div className="w-full">
          <span className="text-sm text-main font-medium">
            Service Category
          </span>
          <h4 className="text-description !text-sm !font-medium">
            {svc_cat_desc}
          </h4>
        </div>
        <div className="w-full">
          <span className="text-sm text-main font-medium">
            Service Type:
          </span>
          <h4 className="text-description !text-sm !font-medium">
            {svc_typ_desc}
          </h4>
        </div>

      </div>
      <div className="relative">
        <Row>
          <div className="w-full">
            Service Cost (USD):<b> {svc_cost_amtf}</b>
          </div>
          {isSelected && (
            <div className="mb-3">
              <label htmlFor="customTextInput">
                Special request to provider below (if any):
              </label>
              <textarea
                placeholder="Example: Please also test for diabetes"
                className="form-control"
                id="customTextInput"
                value={inputValue}
                onChange={handleInputChange}
                rows="4" // Set the number of visible lines to 4
                style={{ marginLeft: '10px', padding: '5px', fontSize: '14px', width: '100%' }}
              />
            </div>
          )}
        </Row>
        <Row>
          <div
            className="w-100 p-3"
          >
            <Button
              className="sign_btn"
              // disabled={isDisabled === svc_id ? false : true}
              style={{ boxSizing: "border-box" }}
              onClick={handleBookie}
              disabled={!isFocused}
            >
              Book Appointment
            </Button>
          </div>
        </Row>
      </div>
    </div>
  );
};
